import React, { useRef, useState, useEffect } from "react";
import { Button } from "@mui/material";
import { FFmpeg } from "@ffmpeg/ffmpeg"; // Usamos solo FFmpeg
import { toBlobURL, fetchFile } from "@ffmpeg/util";

// eslint-disable-next-line no-unused-vars
const ffmpeg = new FFmpeg({ log: true });

const VideoCutter = () => {
  // eslint-disable-next-line no-unused-vars
  const [loaded, setLoaded] = useState(false);
  const ffmpegRef = useRef(new FFmpeg());
  const messageRef = useRef(null);
  const videoRef = useRef(null);
  const [eventos, setEventos] = useState([]);
  const [inicioEvento, setInicioEvento] = useState(null);
  const [videoURL, setVideoURL] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [cargando, setCargando] = useState(false);

  // Cargar FFmpeg al montar el componente
  useEffect(() => {
    const load = async () => {
      const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd";
      const ffmpeg = ffmpegRef.current;
      ffmpeg.on("log", ({ message }) => {
        messageRef.current.innerHTML = message;
      });
      // toBlobURL is used to bypass CORS issue, urls with the same
      // domain can be used directly.
      await ffmpeg.load({
        coreURL: await toBlobURL(
          `${baseURL}/ffmpeg-core.js`,
          "text/javascript"
        ),
        wasmURL: await toBlobURL(
          `${baseURL}/ffmpeg-core.wasm`,
          "application/wasm"
        ),
      });
      setLoaded(true);
    };
    load();
  }, []);

  const manejarInicioEvento = () => {
    if (videoRef.current) {
      setInicioEvento(videoRef.current.currentTime);
    }
  };

  const manejarFinEvento = () => {
    if (videoRef.current && inicioEvento !== null) {
      const nuevoEvento = {
        inicio: inicioEvento,
        fin: videoRef.current.currentTime,
      };
      setEventos([...eventos, nuevoEvento]);
      setInicioEvento(null);
    }
  };

  const manejarCargaVideo = (event) => {
    const file = event.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setVideoURL(url);
      setVideoFile(file);
    }
  };

  const exportarEventos = async () => {
    if (!videoFile || eventos.length === 0) {
      alert("No hay eventos para exportar.");
      return;
    }

    setCargando(true);
    const ffmpeg = ffmpegRef.current;
    // // Usamos fetch para obtener el archivo de video
    // const response = await fetch(URL.createObjectURL(videoFile));
    // const arrayBuffer = await response.arrayBuffer();

    // Escribe el archivo en el sistema de archivos virtual de FFmpeg
    const video = await fetchFile(URL.createObjectURL(videoFile));
    await ffmpeg.writeFile("input.mp4", video);

    // Comandos para cortar los eventos
    // const comandos = [];
    // eventos.forEach((evento, index) => {
    //   comandos.push(
    //     "-i",
    //     "input.mp4",
    //     "-ss",
    //     evento.inicio.toFixed(2),
    //     "-to",
    //     evento.fin.toFixed(2),
    //     "-c",
    //     "copy",
    //     `segmento${index}.mp4`
    //   );
    // });

    // // Ejecutar los comandos para cortar el video
    // await ffmpeg.exec(...comandos);

    // // Crear el archivo de texto para concatenar los segmentos
    // const archivos = eventos.map((_, index) => `segmento${index}.mp4`);
    // const concatTxt = archivos.map((file) => `file '${file}'`).join("\n");

    // // Escribe el archivo de texto para la concatenación
    // await ffmpeg.writeFile("concat.txt", concatTxt);
    // console.log(concatTxt);

    // // Ejecutar el comando para concatenar los segmentos
    // try {
    //   await ffmpeg.exec(
    //     "-f",
    //     "concat",
    //     "-safe",
    //     "0",
    //     "-i",
    //     "concat.txt",
    //     "-c",
    //     "copy",
    //     "output.mp4"
    //   );
    // } catch (error) {
    //   console.error("Error al concatenar los segmentos", error);
    //   setCargando(false);
    //   return;
    // }

    // const files = await ffmpeg.readdir("/"); // Lista los archivos generados
    // console.log("Archivos generados:", files);

    // // Leer el archivo resultante y generar el enlace de descarga
    // const result = await ffmpeg.readFile("output.mp4");
    // const url = URL.createObjectURL(
    //   new Blob([result.buffer], { type: "video/mp4" })
    // );

    // await ffmpeg.exec([
    //   "-i",
    //   "input.mp4",
    //   "-f",
    //   "segment",
    //   "-segment_time",
    //   "3",
    //   "-g",
    //   "9",
    //   "-sc_threshold",
    //   "0",
    //   "-force_key_frames",
    //   "expr:gte(t,n_forced*9)",
    //   "-reset_timestamps",
    //   "1",
    //   "-map",
    //   "0",
    //   "output_%d.mp4",
    // ]);
    try {
      await ffmpeg.exec([
        "-i",
        "input.mp4", // Input file
        "-ss",
        "00:00:10", // Start time
        "-to",
        "00:00:20", // End time
        "-c",
        "copy", // Copy codec (sin recodificar)
        "output.mp4", // Output file
      ]);
    } catch (error) {
      // silently handled
    }
    // try {
    //   await ffmpeg.exec([
    //     "-i",
    //     "output.mp4", // Input file
    //     "-map",
    //     "0", // Start time
    //     "-map",
    //     "0:a", // End time
    //     "-c",
    //     "copy", // Copy codec (sin recodificar)
    //     "output2.mp4", // Output file
    //   ]);
    // } catch (error) {
    //   console.error("Error al cortar el video", error);
    // }

    const data = await ffmpeg.readFile("output.mp4");
    const url = URL.createObjectURL(
      new Blob([data.buffer], { type: "video/mp4" })
    );
    // videoRef.current.src = URL.createObjectURL(
    //   new Blob([data.buffer], { type: "video/mp4" })
    // );
    const a = document.createElement("a");
    a.href = url;
    a.download = "resumen.mp4";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setCargando(false);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: 10 }}>
        <input type="file" accept="video/*" onChange={manejarCargaVideo} />
      </div>
      {videoURL && ( // Solo renderizar el video si videoURL tiene un valor
        <video ref={videoRef} controls width="80%" src={videoURL}>
          Tu navegador no soporta el tag de video.
        </video>
      )}
      <div style={{ marginTop: 10 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={manejarInicioEvento}
        >
          Inicio Evento
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={manejarFinEvento}
          style={{ marginLeft: 10 }}
          disabled={inicioEvento === null}
        >
          Fin Evento
        </Button>
      </div>
      <div
        style={{
          marginTop: 20,
          textAlign: "left",
          width: "80%",
          margin: "auto",
        }}
      >
        <h3>Eventos Guardados</h3>
        <ul>
          {eventos.map((evento, index) => (
            <li key={index}>
              Evento {index + 1}: Inicio - {evento.inicio.toFixed(2)}s, Fin -{" "}
              {evento.fin.toFixed(2)}s
            </li>
          ))}
        </ul>
        {eventos.length > 0 && (
          <Button
            variant="contained"
            color="success"
            onClick={exportarEventos}
            disabled={cargando}
          >
            {cargando ? "Procesando..." : "Exportar Eventos"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default VideoCutter;
